import styled from "styled-components";
import { FlexShared, FlexSharedProps } from "@shared/common/Boxes/Flex";

const Flex = styled.div<FlexSharedProps & { $inline?: boolean }>`
  ${FlexShared};
  display: ${(p) => (p.$inline ? "inline-flex" : "flex")};
`;

export default Flex;
